import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import { style, useGenre, useGenreSet } from '../../api';

import { TrackLink } from '../common/Link';
import { Play } from '../common/Icons';
import TrackImage from '../common/TrackImage';
import { TextBold14, TextRegular12, TextRegular14 } from '../common/Text';
import { noDesktop } from '../../style/constants';

const RelatedTracks = ({ genreId }: { genreId: number }) => {
  const { t } = useTranslation('tracks');
  const tracks = useGenreSet(genreId);
  const genre = useGenre(genreId);

  if (tracks.length === 0 || !genre) {
    return null;
  }

  return (
    <Container>
      <Link href={{ pathname: '/explore', query: { genreId } }}>
        <GenreLink as="div">
          {t('tracks:more') as string} <span>{genre.name}</span>{' '}
          {t('tracks:tracks') as string}
        </GenreLink>
      </Link>
      {tracks.map((el) => (
        <TrackContainer key={el.id}>
          <TrackItem>
            <TrackLink trackId={el.id}>
              <TrackImage src={el.track_img} size={40} />
            </TrackLink>
            <div>
              <TrackLink trackId={el.id}>
                <TextBold14>{el.title}</TextBold14>
              </TrackLink>
              <FlexBox>
                <PlaysAndLikes>
                  <FlexBox>
                    <Play
                      size={16}
                      style={{ marginLeft: -4, marginRight: -4 }}
                    />
                    <TextRegular12>{el.total_plays}</TextRegular12>
                  </FlexBox>
                </PlaysAndLikes>
              </FlexBox>
            </div>
          </TrackItem>
        </TrackContainer>
      ))}
    </Container>
  );
};

export default RelatedTracks;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media ${noDesktop} {
    padding-top: 20px;
  }
`;

const TrackContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 55px;
  margin-bottom: 10px;
`;

const TrackItem = styled.div`
  display: flex;

  ${TrackImage} {
    margin-right: 10px;
  }

  > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: calc(100% - 60px);
  }
`;

const FlexBox = styled.div`
  display: flex;
  align-items: center;
`;

const PlaysAndLikes = styled.div`
  color: ${style.lightGray};
  display: flex;
  align-items: center;

  & span {
    text-transform: uppercase;
    margin-left: 5px;
  }
`;

const GenreLink = styled(TextRegular14)`
  color: ${style.grey_dark_new};
  cursor: pointer;
  span {
    text-decoration: underline;
    text-transform: lowercase;
  }
  margin-bottom: 12px;
`;
